import { BREAKPOINTS } from './breakpoints';

export function getVisibleSlideCount(sliderNode) {
  const computedStyle = getComputedStyle(sliderNode);
  const screenWidth = window.innerWidth;

  if (screenWidth >= BREAKPOINTS.large) {
    return parseInt(computedStyle.getPropertyValue('--slides-per-page-large'), 10) || 1;
  } else if (screenWidth >= BREAKPOINTS.medium) {
    return parseInt(computedStyle.getPropertyValue('--slides-per-page-medium'), 10) || 1;
  } else {
    return parseInt(computedStyle.getPropertyValue('--slides-per-page-small'), 10) || 1;
  }
}

export function applyInitialFetchPriority(sliderNode) {
  const visibleCount = getVisibleSlideCount(sliderNode);
  const allSlides = sliderNode.querySelectorAll('.embla__slide');

  allSlides.forEach((slide, index) => {
    const img = slide.querySelector('img');
    if (!img) return;

    if (index < visibleCount) {
      img.setAttribute('fetchpriority', 'high');
      img.removeAttribute('loading');
    } else {
      img.setAttribute('fetchpriority', 'low');
      img.setAttribute('loading', 'lazy');
    }
  });
}
